import { render } from "./LeaderBoard.vue?vue&type=template&id=69153d9e&scoped=true&ts=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=ts"
export * from "./LeaderBoard.vue?vue&type=script&lang=ts"

import "./LeaderBoard.vue?vue&type=style&index=0&id=69153d9e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69153d9e"]])

export default __exports__